export interface Testimonial {
  id: number;
  name: string;
  location: string;
  service: string;
  rating: number;
  text: string;
  avatar: string;
}

// Aquí irán las reseñas reales cuando lleguen los primeros clientes.
export const testimonials: Testimonial[] = [];
